<template>
	<div class="toolbar-spacer">
		<div>&nbsp;</div>
	</div>
</template>

<script>
export default {
	name: "ToolbarSpacer",
};
</script>

<style lang="scss" scoped>
// set width in the importing component
.toolbar-spacer {
	> div {
		width: 50%;
		height: 100%;
		border-right: 0.0625rem solid $borderColor--dark;
	}
}
</style>
